import { Route, Routes } from 'react-router-dom';
import ChangePasswordPage from './ChangePasswordPage';
import LoginPage from './LoginPage';

export default function LoginPages() {
    return (
        <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/changePassword" element={<ChangePasswordPage />} />
        </Routes>
    );
}
